import { useRef, useState } from "react";
import { Upload, Trash2, FileText } from "lucide-react";
import { assetUrl } from "@/lib/gallery";

const readAsDataUrl = (file) => new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(file); });

export function FloorPlanUpload({ plan, pending, onPick, onRemove, discipline }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (file) => {
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) return;
    setBusy(true);
    onPick({ data_url: await readAsDataUrl(file), filename: file.name, isPdf: file.type === "application/pdf" });
    setBusy(false);
  };
  const preview = pending ? (pending.isPdf ? null : pending.data_url) : assetUrl(plan?.url);
  const name = pending?.filename || plan?.name;
  return (
    <div data-testid="floor-plan-upload">
      <p className="text-xs text-stone-500 mb-3">{discipline === "Architecture" ? "Site plan, floor plans or survey drawing" : "Existing floor plan or layout"} — PNG, JPG or PDF (first page). It opens the client presentation right after the cover.</p>
      <input ref={ref} type="file" accept="image/*,application/pdf" className="hidden" onChange={e => pick(e.target.files?.[0])} data-testid="floor-plan-input" />
      <div className="flex items-start gap-4">
        <div className="w-40 h-28 border border-dashed border-stone-300 bg-white flex items-center justify-center overflow-hidden" data-testid="floor-plan-preview">
          {preview ? <img src={preview} alt="Floor plan preview" className="max-w-full max-h-full object-contain" />
            : name ? <div className="flex flex-col items-center gap-1 text-stone-500 text-[10px] font-mono-lab px-2 text-center"><FileText size={18} /> {name}</div>
            : <span className="text-[10px] text-stone-400 font-mono-lab">NO PLAN</span>}
        </div>
        <div className="flex flex-col gap-2">
          <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="floor-plan-pick-btn" className="inline-flex items-center gap-2 border border-stone-300 px-3 py-2 text-sm hover:border-black disabled:opacity-50"><Upload size={14} /> {name ? "Replace plan" : "Upload floor plan"}</button>
          {name && <button type="button" onClick={onRemove} data-testid="floor-plan-remove-btn" className="inline-flex items-center gap-2 text-xs text-stone-500 hover:text-black"><Trash2 size={12} /> Remove</button>}
          {name && <div className="text-[11px] text-stone-400 truncate max-w-[220px]">{name}</div>}
        </div>
      </div>
    </div>
  );
}
